import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'

export type ConsultasProps = {
    consultas?: {
        inquiryDate: string
        occurrences: number
    }[]
}

export default function Consultas({ consultas }: ConsultasProps) {
    return (
        <>
            <Divider textAlign="center">Consultas</Divider>
            {consultas && consultas.length > 0 && (
                <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                    {consultas.map((consulta, index) => (
                        <Grid key={index} container spacing={1}>
                            <GridItem
                                label={`Mês: ${consulta.inquiryDate}`}
                                value={consulta.occurrences.toFixed(0)}
                                xs={6}
                            />
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    )
}
